import { render, staticRenderFns } from "./cbdata.vue?vue&type=template&id=17b64edd&scoped=true&"
import script from "./cbdata.vue?vue&type=script&lang=js&"
export * from "./cbdata.vue?vue&type=script&lang=js&"
import style0 from "./cbdata.vue?vue&type=style&index=0&id=17b64edd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b64edd",
  null
  
)

export default component.exports